export default {
    fields: {
        i: '№',
        action: 'Event type',
        entityName: 'Type',
        dateTime: 'Time',
        old: 'Old value',
        'new': 'New value',
        userName: 'Initiator of the action',
    },

    orderLog: {
        modal: 'Sent data',
        system: 'System',
        type: {
            created: 'created',
            updated: 'updated',
            event: 'event',
        },
    },

    system: 'system',
};